import { useSelector } from 'react-redux';

import { PLAN_TIER } from '@wetransfer/transfer/constant/plan-tier';

const useAccountType = () => {
  const planTier = useSelector((state) => state?.user?.planTier);

  if (planTier === PLAN_TIER.PLUS) {
    return 'pro_account';
  }

  if (planTier === PLAN_TIER.FREE) {
    return 'free_account';
  }

  return 'anonymous';
};

export default {
  useAccountType,
};
